export const messageRoutes = [
    {
        name: "ward-message",
        path: "/ward/:wardId/message/:messageId",
        component: () => import("@/app/messages/WardMessage"),
        props: true
    },
    {
        name: "ward-message-list",
        path: "/ward/:wardId/message-list",
        component: () => import("@/app/messages/WardMessageList"),
        props: true
    },
    {
        name: "ward-message-inbound-list",
        path: "/ward/:wardId/inbound-message-list",
        component: () => import("@/app/messages/WardInboundMessageList"),
        props: true
    }
]